import { OrderService, WalletService } from "@/services";
import { mapActions } from "vuex";
import * as types from "@/store/types";
import $thousandMask from "@/mixins/thousandMask";
export default {
  name: "order-invoice-card",
  components: {},
  props: ["resultData", "showOrderLimit"],
  mixins: [$thousandMask],
  data() {
    return {
      loadingButton: false
    };
  },
  computed: {
    expireHour() {
      return parseInt(this.resultData.expires_at / 3600000);
    },
    expireMinute() {
      return (
        parseInt(this.resultData.expires_at / 60000) -
        parseInt(this.resultData.expires_at / 3600000) * 60
      );
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      setOrdersData: types.order.actions.SET_ORDERS_DATA,
      walletDataAction: types.wallets.actions.SET_WALLETS,
      setOrderListStep: types.orderListStep.actions.SET_ORDER_LIST_STEP
    }),
    confirmOrder() {
      this.loadingButton = true;
      if (this.showOrderLimit) {
        let data = {
          base_amount: this.resultData.base_amount,
          asset_amount: this.resultData.asset_amount,
          base_change_fee: this.resultData.base_change_fee,
          asset_change_fee: this.resultData.asset_change_fee,
          market_id: this.resultData.market_id,
          direction: this.resultData.direction,
          expires_at: this.resultData.expires_at,
          rate: this.resultData.rate
        };
        OrderService.createMarketOrder(data)
          .then(res => {
            this.$emit("confirmOrder", false);
            this.$toast.success(res.data.message);
            this.$emit("resetAmount", "");
            this.$emit("resetPrice", "");
            this.$emit("resetSliderValue", 0);
            this.$emit("resetTime", true);
            this.$emit("resetOrder", "");
            this.$emit("resetOrderPercent", "");
          })
          .then(() => {
            const filters = {
              sort: "desc"
            };
            OrderService.getMarketOrders(filters).then(response => {
              this.setOrdersData(response.data);
            });
            WalletService.getWallet().then(response => {
              this.walletDataAction(response.data.data);
            });
          })
          .catch(error => {
            if (error.data.code === "user_balance_is_not_enough") {
              this.$emit("openNotification", true);
            }
            this.$emit("confirmOrder", false);
            // this.$toast.error(error.data.message);
          })
          .finally(() => {
            this.loadingButton = false;
            this.setOrderListStep(true);
          });
      } else {
        let data = {
          base_id: this.resultData.from_id,
          base_amount: this.resultData.from_amount,
          asset_id: this.resultData.to_id,
          asset_amount: this.resultData.to_amount,
          order_token: this.resultData.token
        };
        OrderService.createOrder(data)
          .then(res => {
            this.$emit("confirmOrder", false);
            this.$toast.success(res.data.message);
            this.$emit("resetAmount", "");
            this.$emit("resetPrice", "");
          })
          .catch(error => {
            if (error.response.data.code === "user_balance_not_enough") {
              this.$emit("openNotification", true);
            }
            // this.$toast.error(error.response.data.message);
          });
      }
    }
  }
};
